import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'thousandSeparator'
})

/**
 * Thousand Separator Pipe
 */
export class ThousandSeparatorPipe implements PipeTransform {

  /**
   *
   * @param{number} value
   * @param{string} separator
   * @return {number}
   */

  transform(value: any, fractionDigits: number = 2): string {
    // Handle null, undefined, empty string, dash or NaN
    const isSpecialCharc= [null,'-',undefined,'']
    if (
     isSpecialCharc.includes(value) ||
      isNaN(parseFloat(value))
    ) {
      return '0';
    }

    const num = parseFloat(value);
    const formattedValue = num.toFixed(fractionDigits);
    const [intPart, decimalPart] = formattedValue.split('.');

    if (decimalPart === '00') {
      return intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    } else {
      return formattedValue.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
  }

}
